import * as React from "react";
const SvgLunch = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M16.5 2.754a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.5.707V5.3c.89.455 1.5 1.38 1.5 2.45v3.5c0 .443-.23.832-.578 1.054v2.391c.348.223.578.612.578 1.055v5c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-5c0-.373.163-.708.422-.937v-2.627a1.247 1.247 0 0 1-.422-.936v-3.5c0-1.07.61-1.995 1.5-2.45V4.46a.75.75 0 0 1-.5-.707v-1Zm.922 9.746v2h3v-2h-3ZM21 7.75a1.25 1.25 0 0 0-.937-1.21.75.75 0 0 1-.563-.727v-1.31h-1v1.31a.75.75 0 0 1-.563.726A1.25 1.25 0 0 0 17 7.75V11h4V7.75ZM17 16v4.5h4V16h-4ZM12.651 5.5c.815 0 1.602.14 2.335.402-.244.43-.405.913-.463 1.428A5.46 5.46 0 0 0 12.651 7H9.349a5.47 5.47 0 0 0-5.103 3.5H14.5V12H3.25a.75.75 0 0 1-.732-.913A6.97 6.97 0 0 1 9.349 5.5h3.302ZM12.51 13.243c.678.374 1.319.416 1.989.124l.005 1.493-.001.088c-.906.231-1.825.101-2.718-.392-.763-.42-1.478-.42-2.241 0-1.214.67-2.476.67-3.69 0a3.1 3.1 0 0 0-.085-.045.914.914 0 0 0-.769.902v.087a1 1 0 0 0 1 1h8.5V18H4.128a2.251 2.251 0 0 0 2.122 1.5h8.25V21H6.25a3.75 3.75 0 0 1-3.75-3.75.75.75 0 0 1 .75-.75h.458a2.492 2.492 0 0 1-.208-1v-.087c0-.313.06-.612.168-.887l-.056.03a.75.75 0 1 1-.724-1.313c1.084-.598 2.206-.662 3.299-.192a4.541 4.541 0 0 1 .391.192c.763.421 1.478.421 2.241 0 1.214-.67 2.477-.67 3.69 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgLunch;
